const counters = new Map()
const visits = new Map()
const vitals = new Map()
const performanceGuards = new Map()
const MAX_GROUPS = 300
const groupKey = value => [value.pageFamily, value.position || 'page', value.experiment || 'baseline', value.variant || 'control', value.device || 'unknown', value.selectedSize || 'none'].join('|')

export function recordAdDiagnostic(detail) {
  if (!detail?.eligible) return
  const key = groupKey(detail)
  if (!counters.has(key) && counters.size >= MAX_GROUPS) return
  const row = counters.get(key) || { pageFamily: detail.pageFamily, position: detail.position, experiment: detail.experiment, variant: detail.variant, device: detail.device, selectedSize: detail.selectedSize, events: {}, latencySamplesMs: [] }
  row.events[detail.type] = (row.events[detail.type] || 0) + 1
  if (Number.isFinite(detail.durationMs) && row.latencySamplesMs.length < 100) row.latencySamplesMs.push(detail.durationMs)
  counters.set(key, row)
}
export function recordEligibleAdPageView(pageFamily, navigationKey) {
  // Keys stay local and are discarded from exported aggregates.
  visits.set(navigationKey, pageFamily)
  if (visits.size > 1000) visits.delete(visits.keys().next().value)
}
export function recordAdVital(pageFamily, metric) {
  if (!['CLS', 'INP', 'LCP'].includes(metric.name) || !Number.isFinite(metric.value)) return
  vitals.set(`${pageFamily}:${metric.name}`, { pageFamily, metric: metric.name, value: metric.value, rating: metric.rating })
}
export function recordAdPerformanceGuard(pageFamily, type, durationMs = 0) {
  if (!['longtask', 'client_error'].includes(type) || !Number.isFinite(durationMs) || durationMs < 0) return
  const row = performanceGuards.get(pageFamily) || { pageFamily, longTasks: 0, longTaskDurationMs: 0, longestTaskMs: 0, clientErrors: 0 }
  if (type === 'longtask') { row.longTasks++; row.longTaskDurationMs += durationMs; row.longestTaskMs = Math.max(row.longestTaskMs, durationMs) }
  else row.clientErrors++
  performanceGuards.set(pageFamily, row)
}
export function exportAdDiagnostics() {
  const eligiblePageViews = Object.fromEntries([...new Set(visits.values())].map(family => [family, [...visits.values()].filter(value => value === family).length]))
  return { kind: 'local_delivery_diagnostics', financialSource: null, eligiblePageViews, placements: [...counters.values()].map(row => ({ ...row, events: { ...row.events }, latencySamplesMs: [...row.latencySamplesMs] })), vitals: [...vitals.values()], performanceGuards: [...performanceGuards.values()], limitations: 'Document-local aggregates. Render/viewable events are not billed impressions. Page views exclude unknown age and require analytics consent. Vitals and long tasks are document measurements, not causal attribution to ads.' }
}
export function clearAdDiagnostics() { counters.clear(); visits.clear(); vitals.clear(); performanceGuards.clear() }
